import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64100b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-header-g1"
}
const _hoisted_2 = { class: "item-header-desk" }
const _hoisted_3 = { class: "item-header-ju-shoe" }
const _hoisted_4 = { class: "road-map-summary" }
const _hoisted_5 = ["data-label"]
const _hoisted_6 = ["data-label"]
const _hoisted_7 = ["data-label"]
const _hoisted_8 = ["data-label"]
const _hoisted_9 = ["data-label"]
const _hoisted_10 = {
  key: 1,
  class: "item-header-g2"
}
const _hoisted_11 = { class: "item-header-g2-r1" }
const _hoisted_12 = { class: "item-header-desk" }
const _hoisted_13 = { class: "item-header-ju-shoe" }
const _hoisted_14 = { class: "item-header-g2-r2" }
const _hoisted_15 = { class: "road-map-summary" }
const _hoisted_16 = ["data-label"]
const _hoisted_17 = ["data-label"]
const _hoisted_18 = ["data-label"]
const _hoisted_19 = ["data-label"]
const _hoisted_20 = ["data-label"]
const _hoisted_21 = {
  key: 2,
  class: "item-body-g1"
}
const _hoisted_22 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_23 = {
  key: 1,
  class: "is-at-this-table"
}
const _hoisted_24 = {
  key: 3,
  class: "item-body-g2"
}
const _hoisted_25 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_26 = {
  key: 1,
  class: "is-at-this-table"
}
const _hoisted_27 = {
  key: 4,
  class: "is-reserved"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map = _resolveComponent("road-map")!

  return (_openBlock(), _createElementBlock("div", {
    class: "loby-item-root",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click')), ["stop"]))
  }, [
    (_ctx.displayType === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tableName), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["item-header-timer", _ctx.timerColor])
          }, _toDisplayString(_ctx.currentCount !== -1 ? _ctx.currentCount : ''), 3),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.mData.downLimit + '-' + _ctx.mData.upLimit), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "road-map-summary-item",
              "data-color": "red",
              "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                    ? _ctx.t('roadmap.banker')
                    : _ctx.t('roadmap.dragon')
                    
            }, _toDisplayString(_ctx.redCount), 9, _hoisted_5),
            _createElementVNode("div", {
              class: "road-map-summary-item",
              "data-color": "blue",
              "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                    ? _ctx.t('roadmap.player')
                    : _ctx.t('roadmap.tiger')
                    
            }, _toDisplayString(_ctx.blueCount), 9, _hoisted_6),
            _createElementVNode("div", {
              class: "road-map-summary-item",
              "data-color": "green",
              "data-label": _ctx.t('roadmap.tie')
            }, _toDisplayString(_ctx.greenCount), 9, _hoisted_7),
            (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "road-map-summary-item",
                  "data-color": "red",
                  "data-label": _ctx.t('roadmap.pair')
                }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "road-map-summary-item",
                  "data-color": "blue",
                  "data-label": _ctx.t('roadmap.pair')
                }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.tableName) + " " + _toDisplayString(_ctx.mData.tableNo), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.mData.downLimit + '-' + _ctx.mData.upLimit), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "red",
                "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
              }, _toDisplayString(_ctx.redCount), 9, _hoisted_16),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "blue",
                "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
              }, _toDisplayString(_ctx.blueCount), 9, _hoisted_17),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "green",
                "data-label": _ctx.t('roadmap.tie')
              }, _toDisplayString(_ctx.greenCount), 9, _hoisted_18),
              (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "road-map-summary-item",
                    "data-color": "red",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "road-map-summary-item",
                    "data-color": "blue",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_20))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["item-header-timer", _ctx.timerColor])
            }, _toDisplayString(_ctx.currentCount !== -1 ? _ctx.currentCount : ''), 3)
          ])
        ])),
    (_ctx.displayType === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_road_map, {
            class: "road-map",
            mapData: _ctx.mData.expand.resultList,
            gameType: _ctx.mData.gameTypeNo.toUpperCase() === 'G002' ? 1 : 2,
            onRoadMapData: _ctx.onRoadMapDataParsed,
            beadRowCount: 10
          }, null, 8, ["mapData", "gameType", "onRoadMapData"]),
          (_ctx.isAtThisTable && _ctx.mData.status !== 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.t('loby.atthistable')), 1))
            : _createCommentVNode("", true),
          (_ctx.mData.status === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('game.shuffling')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_road_map, {
            class: "road-map",
            mapData: _ctx.mData.expand.resultList,
            gameType: _ctx.mData.gameTypeNo.toUpperCase() === 'G002' ? 1 : 2,
            onRoadMapData: _ctx.onRoadMapDataParsed,
            beadRowCount: 10,
            display: 2
          }, null, 8, ["mapData", "gameType", "onRoadMapData"]),
          (_ctx.isAtThisTable && _ctx.mData.status !== 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.t('loby.atthistable')), 1))
            : _createCommentVNode("", true),
          (_ctx.mData.status === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('game.shuffling')), 1)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.mData.reserverd > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27))
      : _createCommentVNode("", true)
  ]))
}